import React, { useContext } from "react";
import LBint from "../productPages/LBint";
import LFsa from "../productPages/LFsa";
import LVsa from "../productPages/LVsa";
import LHfsp from "../productPages/LHfsp";
import LFsbi from "../productPages/LFsbi";
import { data as DATA_PRODUCTS } from "../DATA_PRODUCTS";

import OpacityContext from "../OpacityContext";
// import "../productPages/pageAndProductStyle.css"; //* move this import to Direct.js, create a new one called progPageAndProductStyle.css for Programmatic.js

export default function PageLFD({
  handleWarningMessageText,
  handleDropzoneChanges,
  handleContinueButtonDisabled
}) {
  const { productIndex } = useContext(OpacityContext);
  // Map product label to component
  // const label = DATA_PRODUCTS[productIndex]?.label;
  const componentMap = {
    bint: LBint,
    fsa: LFsa,
    fsbi: LFsbi,
    hfsp: LHfsp,
    vsa: LVsa
  };

  //* get the label name based on productIndex
  const label =
    DATA_PRODUCTS[productIndex] && DATA_PRODUCTS[productIndex].label; //* this is mapping the label to the data with a safe check bc our compiler doesn't support optional chaining

  //* We will create a dynamic component that gets selected and we will render out just that instead of listing out conditional renders for each one
  const ProductComponent = componentMap[label];

  return (
    <div className="pageContainer pageContainerLFD">
      {ProductComponent && (
        <ProductComponent
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      )}
    </div>
  );
}

/*
  return (
    <div className="pageContainer pageContainerLFD">
      {productIndex === 0 ? (
        <LBint
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      ) : null}
      {productIndex === 1 ? (
        <LFsa
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      ) : null}
      {productIndex === 2 ? (
        <LHfsp
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      ) : null}
      {productIndex === 3 ? (
        <LVsa
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      ) : null}
      {productIndex === 4 ? (
        <LFsbi
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      ) : null}
    </div>
  );
}
*/
